import Cookies from 'js-cookie';


export function getAuthHeaders() {
  const user = Cookies.get("user");
  let headers = {};
  if (user) {
    const token = JSON.parse(user)?.access;
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }
  }
  return headers;
}



const APIURL = 'https://avionica.csdevhub.com';
// const APIURL = 'https://uat.avioflai.com';

// eslint-disable-next-line import/no-anonymous-default-export
// export default { APIURL, getAuthHeaders };
export default APIURL;




